import { TabNoData } from "../components/common/NoData";
import TextNavBackground from "../components/common/TextNavBackground";
import PollListCard from "../components/elements/polls/PollListCard";
import { apiWrapper } from "../utils/api/apiWrapper";
import { kNewPollListURL } from "../utils/constants/apiUrls";
import { GUEST_TOKEN } from "../utils/constants/names";
import { ONE_DAY_REFRESH_INTERVAL_SECONDS } from "../utils/constants/numbers";
import { customStaticSeoConfig } from "../utils/helpers/helpers";

const PollList = ({ polls }) => {
  return (
    <>
      {customStaticSeoConfig("Polls")}

      <TextNavBackground title="Polls" />

      <TabNoData />

      {/* <section className="py-6 sm:py-1200 text-gray-100 max-w-7xl mx-auto lg:max-w-7xl">
        <div className="container p-6 mx-auto space-y-8">
          <div className="grid grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2 lg:grid-cols-4">
            {polls.map((poll) => (
              <PollListCard key={poll.id} poll={poll} />
            ))}
          </div>
        </div>
      </section> */}
    </>
  );
};

export default PollList;

export const getStaticProps = async (context) => {
  const token = process.env.GUSET_USER_TOKEN
    ? process.env.GUSET_USER_TOKEN
    : GUEST_TOKEN;

  const polls = await apiWrapper.get(kNewPollListURL, token);

  return {
    props: {
      polls: polls?.data,
    },
    revalidate: ONE_DAY_REFRESH_INTERVAL_SECONDS,
  };
};
